import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initialState } from '../../../data/billing/cpiSetup/initialState.cpiSetup.data';
import {
  getCpiByCountry as getCpiByCountryAPI,
  searchCpiByCountry as searchCpiByCountryAPI,
  searchCPISetupTabData as searchCPISetupTabDataAPI,
  continueCpi as continueCpiAPI,
  updateContractCpi as updateContractCpiAPI,
  removeCpi as removeCpiAPI,
  resetCpi as resetCpiAPI,
  putCpiSetupLockDown as putCpiSetupLockDownAPI,
  getCpiSetupLockDown as getCpiSetupLockDownAPI,
  getCpiHistory as getCpiHistoryAPI,
} from '../../../apis/billingAPI';

import { ACTIONS_CPISETUP } from '../../../constants/actionCreator';
import { CPISETUP, CPI_SETUP } from '../../../constants';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { v4 as uuidv4 } from 'uuid';

//cpi setup & updates apis
//go button api

export const getCpiByCountry = createAsyncThunk(
  ACTIONS_CPISETUP.getCountry,
  async (body, { rejectWithValue }) => {
    try {
      const response = await getCpiByCountryAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
//search cpi by country
export const searchCpiByCountry = createAsyncThunkWrapper(
  ACTIONS_CPISETUP.searchByCPI,
  searchCpiByCountryAPI
);

//continue save api

export const continueCpi = createAsyncThunkWrapper(
  ACTIONS_CPISETUP.continueCpi,
  continueCpiAPI
);

export const searchCPISetupTabData = createAsyncThunkWrapper(
  ACTIONS_CPISETUP.searchCPISetupTab,
  searchCPISetupTabDataAPI
);

export const removeCpi = createAsyncThunkWrapper(
  ACTIONS_CPISETUP.remove,
  removeCpiAPI
);

export const updateContractCpi = createAsyncThunkWrapper(
  ACTIONS_CPISETUP.updateCpi,
  updateContractCpiAPI
);

export const resetCpi = createAsyncThunkWrapper(
  ACTIONS_CPISETUP.reset,
  resetCpiAPI
);

export const putCpiSetupLockDown = createAsyncThunkWrapper(
  ACTIONS_CPISETUP.putCpiSetupLockdown,
  putCpiSetupLockDownAPI
);

export const getCpiSetupLockDown = createAsyncThunkWrapper(
  ACTIONS_CPISETUP.getCpiSetupLoackdown,
  getCpiSetupLockDownAPI
);

export const getCpiHistory = createAsyncThunkWrapper(
  ACTIONS_CPISETUP.GETSPIHISTORY,
  getCpiHistoryAPI
);

// Reducer and Actions
const cpiSetupSlice = createSlice({
  name: CPISETUP.cpiSetup,
  initialState,
  reducers: {
    handleCpiUpdateResponse: (state, action) => {
      state.CpiUpdateResponse =
        action?.payload || initialState.CpiUpdateResponse;
    },
    handlesetSelectedTabValue: (state, action) => {
      state.tabVal = action?.payload ? action?.payload : 0;
    },
    handleSelectionGridData: (state, action) => {
      state.handleSelectedRowData = action.payload;
    },
    resetGridValues: (state) => {
      state.billingSearchData = initialState.billingSearchData;
      state.handleSelectedRowData = initialState.handleSelectedRowData;
      state.billingSearchCount = initialState.billingSearchCount;
    },
    resetDefaultGrid: (state) => {
      state.countryDefaultData = initialState.countryDefaultData;
      state.isCountryDataFound = false;
    },
    setDefaultGrid: (state, action) => {
      state.countryDefaultData = action?.payload;
    },
    setSearchParams: (state, action) => {
      state.searchParams[action.payload.key] = action.payload.value;
    },
    setSelectedGridRowsData: (state, action) => {
      if (action?.payload.length > 0) {
        state.gridRowSelectedData = action?.payload;
        state.gridRowSelectedCount = action?.payload?.length || 0;
        state.rowArray[state.currentPage ? state.currentPage : 1] =
          action?.payload;
      }
    },
    setcpiSetupTabGrid: (state, action) => {
      state.cpiSetupTabGrid = action?.payload;
    },
    setCpiDateValue: (state, action) => {
      state.cpiDate = action?.payload;
    },
    dataReset: (state) => {
      Object.keys(state).forEach((key) => {
        if (key !== 'cpiDate') {
          state[key] = initialState[key];
        }
      });
    },
    handleHistoryData: (state, action) => {
      state.historyData = action?.payload || [];
    },
    handleSetLockDown: (state, action) => {
      state.isLockDown = action?.payload;
    },
    setCpiSetupTabOpenValue: (state, action) => {
      state.isCpiSetupTabOpen = action?.payload;
    },
    setshowTabsValue: (state, action) => {
      state.showTabs = action?.payload;
    },
    setgoValue: (state, action) => {
      state.go = action?.payload;
    },
    setNoShowValue: (state, action) => {
      state.noShow = action?.payload;
    },
    handleCurrentPage: (state, action) => {
      state.currentPage = action?.payload;
    },
    handleRowArray: (state, action) => {
      state.rowArray = [];
    },
  },
  extraReducers: (builder) => {
    builder
      //latest go button country cpi default grid
      .addCase(getCpiByCountry.pending, (state) => {
        state.isLoadExists = true;
        state.APIRESPONSECOUNTRY = '';
        state.goData = '';
      })
      .addCase(getCpiByCountry.fulfilled, (state, action) => {
        state.isLoadExists = false;
        state.APIRESPONSECOUNTRY = 'success';
        state.goData = action?.payload || [];
      })
      .addCase(getCpiByCountry.rejected, (state, action) => {
        state.isLoadExists = false;
        state.APIRESPONSECOUNTRY = 'failed';
        state.goData = action?.payload?.response?.data || [];
      })

      //cpi default grid
      .addCase(searchCpiByCountry.pending, (state) => {
        state.isCountryDataFound = null;
        state.countryDefaultData = [];
      })
      .addCase(searchCpiByCountry.fulfilled, (state, action) => {
        state.isCountryDataFound = action?.payload?.cpi?.length > 0;
        state.countryDefaultData = action?.payload?.cpi?.map((item) => ({
          ...item,
          cpiPercentage: item?.cpiPercentage
            ? parseFloat(item?.cpiPercentage).toFixed(2)
            : '',
          id: uuidv4(),
        }));
        state.totalCountDefault = action?.payload?.totalRecords;
      })

      .addCase(searchCpiByCountry.rejected, (state) => {
        state.isCountryDataFound = true;
        state.countryDefaultData = [];
      })

      // cpisetup tab grid
      .addCase(searchCPISetupTabData.pending, (state) => {
        state.cpiSetupTabGridLoading = null;
        state.cpiSetupTabGrid = [];
        state.contractAPIResponse = '';
      })
      .addCase(searchCPISetupTabData.fulfilled, (state, action) => {
        state.cpiSetupTabGridLoading = action?.payload?.cpi?.length > 0;
        state.cpiSetupTabGrid = action?.payload?.cpi || [];
        state.cpiTabTotal = action?.payload?.totalRecords || 0;
        if (state.cpiSetupTabGrid.length === 0) {
          state.contractAPIResponse = 'success';
        }
      })
      .addCase(searchCPISetupTabData.rejected, (state) => {
        state.cpiSetupTabGridLoading = true;
        state.cpiSetupTabGrid = [];
        state.contractAPIResponse = 'fail';
      })

      //cpi amount update
      .addCase(updateContractCpi.pending, (state) => {
        state.cpiAmountLoading = true;
        state.CpiUpdateResponse = '';
        state.contractNameList = '';
      })
      .addCase(updateContractCpi.fulfilled, (state, action) => {
        state.cpiAmountLoading = false;
        state.CpiUpdateResponse = action?.payload?.succeeded;
        state.contractNameList = action?.payload?.message;
      })
      .addCase(updateContractCpi.rejected, (state, action) => {
        state.cpiAmountLoading = false;
        state.CpiUpdateResponse = '';
        state.contractNameList = action?.payload?.message;
      })
      //cpi remove

      .addCase(removeCpi.pending, (state) => {
        state.removeLoading = true;
        state.removeResponse = [];
      })
      .addCase(removeCpi.fulfilled, (state, action) => {
        state.removeLoading = false;
        state.removeResponse = action?.payload;
      })
      .addCase(removeCpi.rejected, (state) => {
        state.removeLoading = false;
        state.removeResponse = [];
      })

      //continue
      .addCase(continueCpi.pending, (state) => {
        state.continueLoading = true;
        state.continueResponse = [];
        state.countryContinue = 'fail';
      })
      .addCase(continueCpi.fulfilled, (state, action) => {
        state.continueLoading = false;
        state.continueResponse = action?.payload;
        state.countryContinue = 'success';
      })
      .addCase(continueCpi.rejected, (state) => {
        state.continueLoading = false;
        state.continueResponse = [];
        state.countryContinue = 'fail';
      })

      //reset cpi
      .addCase(resetCpi.pending, (state) => {
        state.resetLoading = true;
        state.resetResponse = '';
        state.resetAPIResponse = 'fail';
      })
      .addCase(resetCpi.fulfilled, (state, action) => {
        state.resetLoading = false;
        state.resetResponse = action?.payload;
        state.resetAPIResponse = 'success';
      })
      .addCase(resetCpi.rejected, (state) => {
        state.resetLoading = false;
        state.resetResponse = '';
        state.resetAPIResponse = 'fail';
      })

      // cpi setup lockdown
      .addCase(getCpiSetupLockDown.pending, (state) => {
        state.cpiGetLockdonwResponse = [];
      })
      .addCase(getCpiSetupLockDown.fulfilled, (state, action) => {
        state.cpiGetLockdonwResponse = action?.payload;
        if (
          action?.payload?.lock_Flag?.toLowerCase() === CPI_SETUP.valueForY &&
          action?.payload?.completed_Flag?.toLowerCase() === CPI_SETUP.valueForN
        ) {
          state.isLockDown = true;
        }
      })
      .addCase(getCpiSetupLockDown.rejected, (state) => {
        state.cpiGetLockdonwResponse = [];
      })

      .addCase(putCpiSetupLockDown.pending, (state) => {
        state.cpiPutLockdonwResponse = [];
      })
      .addCase(putCpiSetupLockDown.fulfilled, (state, action) => {
        state.cpiPutLockdonwResponse = action?.payload;
        state.isLockDown = true;
      })
      .addCase(putCpiSetupLockDown.rejected, (state) => {
        state.cpiPutLockdonwResponse = [];
        state.isLockDown = false;
      })

      .addCase(getCpiHistory.pending, (state) => {
        state.historyRecords = [];
      })
      .addCase(getCpiHistory.fulfilled, (state, action) => {
        state.historyRecords = action?.payload?.cpiSetupHistory || [];
      })
      .addCase(getCpiHistory.rejected, (state) => {
        state.historyRecords = [];
      });
  },
});

export const {
  handlesetSelectedTabValue,
  resetGridValues,
  handleSelectionGridData,
  resetDefaultGrid,
  setDefaultGrid,
  setSearchParams,
  setSelectedGridRowsData,
  setcpiSetupTabGrid,
  dataReset,
  handleCpiUpdateResponse,
  setCpiDateValue,
  handleHistoryData,
  handleSetLockDown,
  setCpiSetupTabOpenValue,
  setshowTabsValue,
  setgoValue,
  setNoShowValue,
  handleCurrentPage,
  handleRowArray,
} = cpiSetupSlice.actions;
export default cpiSetupSlice.reducer;
